import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import QRCode from './qr-code-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <QRCode {...validProps} />;
}
SvgComponent.iconName = 'alignRight';

/**
 * @deprecated This is a legacy icon
 */
export const QRCodeIcon = svgIconWrapper(SvgComponent);
